/* eslint no-param-reassign: 0 */

import moment from "moment-timezone";

const initialState = {};

const gettersDef = {};

const convertDatetimeToUTCString = (datetime, timezone) => {
  return moment.utc(
    moment.tz(datetime.replace(':00Z', ''), 'YYYY-MM-DD HH:mm:ss', timezone).format()
  ).format()
}

const normaliseDatetimes = (data) => {
  return {
    ...data,
    startDatetime: data.startDatetime ? convertDatetimeToUTCString(data.startDatetime, data.timezone) : data.startDatetime,
    endDatetime: data.endDatetime ? convertDatetimeToUTCString(data.endDatetime, data.timezone) : data.endDatetime
  }
}

const actions = {
  fetchBriefs({ dispatch, rootGetters }, { params = {} } = {}) {
    const mergedParams = {
      ...params,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/brapp/briefs/", params: mergedParams },
      { root: true }
    );
  },
  fetchBriefReport({ dispatch }, { id, params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/brapp/brief-responses/${id}/`, params },
      { root: true }
    );
  },
  createBrief({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/brapp/briefs/", data: normaliseDatetimes(data) },
      { root: true }
    );
  },
  duplicateBrief({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: `/brapp/briefs/${id}/duplicate/` },
      { root: true }
    );
  },
  deleteBrief({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `/brapp/briefs/${id}` },
      { root: true }
    );
  },
  fetchBrief({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/brapp/briefs/${id}/` },
      { root: true }
    );
  },
  fetchQuestions({ dispatch }, { params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/brapp/brief-questions/", params },
      { root: true }
    );
  },
  updateBrief({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `/brapp/briefs/${data.id}/`, data: normaliseDatetimes(data) },
      { root: true }
    );
  },
  patchBrief({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `/brapp/briefs/${data.id}/`, data: normaliseDatetimes(data) },
      { root: true }
    );
  },
  addQuestion({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/brapp/brief-questions/", data },
      { root: true }
    );
  },
  updateQuestion({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `/brapp/brief-questions/${data.id}/`, data },
      { root: true }
    );
  },
  deleteQuestion({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `/brapp/brief-questions/${id}` },
      { root: true }
    );
  },
  addQuestionAnswer({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/brapp/brief-question-answers/", data },
      { root: true }
    );
  },
  fetchBriefQuestionAnswers({ dispatch }, { params = {} }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/brapp/brief-response-answers/", params },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
